module.exports = require("https");


/*****************
 ** WEBPACK FOOTER
 ** external "https"
 ** module id = 122
 ** module chunks = 0
 **/